import * as angular from 'angular';
import * as _ from 'lodash';

import { ApplicationUserViewModel, ComponentDefinition, ObjectUser, UserGroups } from '@models/index';
import { IapplicationUserService, ICurrentApplicationService, ILoggerService, IUserGroupsService, IStoreService } from '@services/index';
import { MixedUserChoice, UserType } from '../../../models/mailing/MixedUserChoice';
import { StoreElement } from '../../../stateManagement';
import { SaveCancelObject } from './SaveCancelObject';

class UserGroupsController implements angular.IComponentController {
    choices: MixedUserChoice[];
    contextualFormController: angular.IFormController;
    formController: angular.IFormController;
    isApplicationLocked: boolean;
    isEditMode: boolean;
    isLoading: boolean;
    loadingMessage: string;
    selectedChoices: MixedUserChoice[];
    selectedItem: UserGroups;
    userGroups: UserGroups[];
    users: ApplicationUserViewModel[];
    saveCancelObject: SaveCancelObject;
    usageList: { [id: string]: ObjectUser[] } = {};
    usages: ObjectUser[];
    canDelete: boolean = false;

    private _unsubscribe: () => void;

    static $inject = [
        '$translate',
        'applicationUserService',
        'currentApplicationService',
        'loggerService',
        'userGroupsService',
        'storeService',
    ];

    constructor(
        private _$translate: angular.translate.ITranslateService,
        private _applicationUserService: IapplicationUserService,
        private _currentApplicationService: ICurrentApplicationService,
        private _loggerService: ILoggerService,
        private _userGroupsService: IUserGroupsService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this._applicationUserService
            .getUsers(this._currentApplicationService.getApplicationConfiguration().guid)
            .then((responses) => {
                this.users = responses;
                this.choices = this.users.map(u => {
                    return {
                        type: UserType.User,
                        name: u.name,
                        originalObject: u as any
                    };
                });
            });
        this._unsubscribe = this._storeService.register(
            store => {
                let userGroups = Object.values(store.userGroups.dictionary);
                userGroups = userGroups.sort(this.sortChoices);
                this.userGroups = userGroups;
                this.isEditMode = store.layout.value.isEditMode;
                this.isApplicationLocked = store.application?.value?.isLocked;
                if (this.selectedItem) {
                    this.selectedItem = _.find(this.userGroups, (u) => this.selectedItem.guid === u.guid);
                }
            },
            [StoreElement.Layout, StoreElement.UserGroups]
        );
        this._userGroupsService
            .getUsage(true)
            .then(data => {
                data.forEach(d => {
                    const arr = this.usageList[d.guid] || [];
                    arr.push(d);
                    this.usageList[d.guid] = arr;
                });
            })
            .catch(reason => {
                this._loggerService.logError(this._$translate.instant(reason));
            });
        this.selectedChoices = [];
    }

    selectItem(userGroup: UserGroups, $event) {
        if (!$event.isDefaultPrevented() && !this.formController?.$dirty) {
            this.selectedItem = userGroup;
            this.selectedChoices = [];
            if (userGroup != null) {
                for (let i = 0; i < userGroup.userCollection.length; i++) {
                    const user = this.users.find(c => c.userId === userGroup.userCollection[i]);
                    if (user !== undefined) {
                        this.selectedChoices.push({
                            type: UserType.User,
                            name: user.name,
                            originalObject: user as any
                        });
                    }
                }
            }
            $event.preventDefault();
        }
    }

    onRequestDelete(userGroup: UserGroups) {
        this.canDelete = false;
        if (userGroup) {
            if (this.usageList[userGroup.guid]?.length > 0) {
                this.canDelete = false;
                this.usages = this.usageList[userGroup.guid];
            } else {
                this.canDelete = true;
            }
        }
    }

    deleteOne(userGroup: UserGroups) {
        if (userGroup) {
            if (this.canDelete) {
                this._storeService
                    .dispatchers()
                    .userGroups.deleteOne(userGroup)
                    .then((data) => {
                        this.selectedItem = null;
                        this._loggerService.logSuccess(this._$translate.instant('Successfully deleted user group.'));
                        this.formController.$setPristine();
                        this.selectedChoices = this.selectedChoices.sort(this.sortChoices);
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.selectedChoices = [];
                    });
            }
        }
    }

    drop(userGroupToAdd) {
        if (userGroupToAdd.itemId === 'addUserGroup') {
            if (userGroupToAdd) {
                this.selectedItem = userGroupToAdd;
                this.userGroups.push(userGroupToAdd);
            }
        }
    }

    save() {
        return this.saveCancelObject.save();
    }

    cancel() {
        this.saveCancelObject.cancel();
        this.isEditMode = false;
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    //todo extract do common functions
    private sortChoices(a: { name: string }, b: { name: string }): number {
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    }
}

export const wtUserGroups: ComponentDefinition = {
    componentId: 'wtUserGroups',
    controller: UserGroupsController,
    template: require('./userGroups.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        isLoading: '=',
        selectedChoices: '=',
        selectedItem: '=',
        userGroups: '=',
        saveCancelObject: '<'
    }
};
